// extracted by mini-css-extract-plugin
export default {"input":"InputStyles_input__KwQab","label":"InputStyles_label__VbFPM"};